import { executeRequest, JFSRequest } from '@jfs/network'
import { dateFormatter, DateFormatTypes } from '@jfs/utils'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const resp = isSuccessResponse(response)
  const retData = {
    content: resp?.items?.map((item) => ({
      check: 'false',
      id: item?.id,
      processingEntity: item?.processingEntity ?? 'NA',
      bankName: item?.bankName ?? 'NA',
      mid: item?.emsEntityId ?? 'NA',
      tid: item?.emsTerminalId ?? 'NA',
      emsBusinessCategory: item?.emsBusinessCategory ?? 'NA',
      emsBusinessName: item?.emsBusinessName ?? 'NA',
      emsBankEntityId: item?.emsBankEntityId ?? 'NA',
      emsBankTerminalId: item?.emsBankTerminalId ?? 'NA',
      createdAt: item?.createdAt?.split('T')?.[0]  ?? 'NA',
      eecCreatedAt: item?.eecCreatedAt?.split('T')?.[0] ?? 'NA',
    })),
    page: {
      totalElements: resp?.totalItems,
      totalPages: resp?.totalPages,
      number: resp?.currentPage,
    },
  }
  return retData
}

const fetchPosApprovals = (req: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.fetchApprovals),
    method: 'POST',
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: req,
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { fetchPosApprovals }
